import { PostInquiryData, Inquiry } from '../models/inquiriesModel'
import { API } from './apiClient'

export const postInquiry = (inquiry: PostInquiryData, onetimeKey: string): Promise<Inquiry> => {
  return API.post(`/inquiry`, inquiry, {
    headers: { Authorization: onetimeKey },
  })
}

export const postInquiryImage = (inquiryId: string, onetimeKey: string, file: File): Promise<void> => {
  const formData = new FormData()
  formData.append('file', file)

  return API.post(`/inquiry/${inquiryId}/image`, formData, {
    headers: { Authorization: onetimeKey, 'content-type': 'multipart/form-data' },
    timeout: 30000,
  })
}
